import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { JobService } from '../../core/job.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    selector: 'job-card',
    templateUrl: './job-card.html',
    standalone: true,
    imports: [CommonModule, LowerCasePipe]
})
export class JobCardComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  @Input() id: string = '';
  @Input() uid: string = '';
  @Input() highlights: boolean = true;
  @Input() image: boolean = true;

  job: any;
  directory: any = globals.directory;
  directory_data: any;

  constructor(
    private js: JobService,
  ) {}

  ngOnInit() {
    if (this.id) {
      this.js.jobDetail(this.id).subscribe(job => {
        this.job = job;
        if(this.job.country) {
          this.directory_data = this.directory[this.job.country];
        }
      })
    }
  }
}
